import React from "react";
import { NoPic } from "../../exports/Images";

const DocVideos = ({ feature_videos }) => {
  return (
    <div className="gym-benefits-container mt30">
      {feature_videos.map((videos, index) => {
        return (
          <div className="gym-benefit-box" key={index}>
            <p className="gym-benefit-label">{videos?.video_title || "NA"}</p>
            <div className="horizontal-gay-line"></div>

            {videos?.video_path ? (
              <video width="320" height="240" controls>
                <source src={videos.video_path} type="video/mp4" />
                <source src={videos.video_path} type="video/ogg" />
              </video>
            ) : (
              <img
                src={NoPic}
                alt={videos?.video_title || "N/A"}
                className="gym-benefit-image"
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default DocVideos;
